module.exports = __webpack_public_path__ + "static/media/ruksana.269cb68b.jpg";